import { put } from 'redux-saga/effects'
import { Game } from '../../Core'

export function* loadComponents() {
  const components = {}

  yield put(Game.actions.registerComponents(components))
}

export function* init() {
  yield loadComponents()
}

export function* sagas() {
  yield init()
}
